/**
 * FailureIcon/index.js
 * desc: notification failure icon
 * note: status icon via IconButton; defaults its tooltip + accessible name to the
 *       status label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const FailureIcon = ({ tooltip, ...props }) => (
    <IconButton baseClassName="failure icon" label={ tooltip || translate('icons.failure.tooltip.text') } tooltip={ tooltip } { ...props }>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 19"><path fillRule="evenodd" d="M22 19L11 0 0 19h22zm-12-3v-2h2v2h-2zm0-4h2V8h-2v4z"/></svg>
    </IconButton>
);


export default FailureIcon;
